<template>
  <div>
    <ToolbarComponent
      :query="query"
      :force-hide-auto-complete="true"
      @search="onSearch"
    />
    <div v-if="selectedTab === 'STORES'" class="stores_filter_parent">
      <div class="stores_filter_child">
        <div class="featured_stores_filters">
          <span class="see_all" @click.stop="showFeaturedStores()">All</span> - <span class="see_all" @click.stop="showFeaturedStores('male')">Men</span> - <span
            class="see_all"
            @click.stop="showFeaturedStores('female')"
          >Women</span>
        </div>
      </div>
    </div>
    <tabs ref="tabs" class="tabs" :class="{'filter': selectedTab === 'STORES'}">
      <tab
        v-if="featured !== 'stores'"
        :selected="selectedTab === 'ITEMS'"
        :name="getItemsTabName"
        @onTabSelected="onTabSelected('ITEMS')"
      >
        <SearchStoreFilterComponent
          :results="items"
          :category="category"
          :hide-grid-type="true"
          @filterProducts="filterProducts"
        />
        <div class="search_grid">
          <BaseGridComponent
            :filter="filter"
            :type="'ITEMS'"
            :featured="featured"
            :search="query"
            :screen="'search'"
            :category="category"
            @updateCounter="updateCounter('ITEMS' ,$event)"
          />
        </div>
        <div v-if="finishLoadItems && items === 0" class="gotit_search_not_fount">
          No items found. Try another search
        </div>
      </tab>
      <tab
        v-if="query"
        :name="'People'"
        @onTabSelected="onTabSelected('PEOPLE')"
      >
        <div class="search_grid">
          <BaseGridComponent
            :type="'PEOPLE'"
            :search="query"
            :category="category"
            @updateCounter="updateCounter('PEOPLE' ,$event)"
          />
        </div>
        <div v-if="finishLoadPeople && people === 0" class="gotit_search_not_fount">
          No People Found. Try another search
        </div>
      </tab>
      <tab
        v-if="query || featured === 'stores'"
        :selected="selectedTab === 'STORES'"
        :name="featuredFilter === 'male'? 'Stores (Men\'s)' : featuredFilter === 'female' ? 'Stores (Women)' : 'Stores (All)'"
        @onTabSelected="onTabSelected('STORES')"
      >
        <div v-if="query" class="search_grid">
          <BaseGridComponent :type="'STORES'" :search="query" :category="category" @updateCounter="updateCounter('STORES' ,$event)" />
        </div>
        <div v-else class="search_grid">
          <BaseGridComponent :type="'STORES'" :search-featured="'store'" :featured-filter="featuredFilter" :category="category" @updateCounter="updateCounter('STORES' ,$event)" />
        </div>
        <div v-if="finishLoadStores && stores === 0" class="gotit_search_not_fount">
          No Stores Found. Try another search
        </div>
      </tab>
    </tabs>
  </div>
</template>

<script>
import BaseGridComponent from '../../components/BaseGridComponent'
import ToolbarComponent from '../../components/ToolbarComponent'
import Tabs from '../../components/Tabs'
import Tab from '../../components/Tab'
import AuthenticatedPage from '../../components/AuthenticatedPage'
import SearchStoreFilterComponent from '../../components/SearchStoreFilterComponent'

export default {
  name: 'Index',
  components: { SearchStoreFilterComponent, Tab, Tabs, ToolbarComponent, BaseGridComponent },
  extends: AuthenticatedPage,
  asyncData ({ query, store }) {
    let title = 'Search'
    if (query.category) {
      switch (query.category) {
        case '21':
          title = 'Men\'s'
          break
        case '68':
          title = 'Women\'s'
          break
        case '25':
          title = 'Recomended'
          break
      }
    } else if (query.featured) {
      switch (query.featured) {
        case '1':
          title = 'Spacial Deals'
          break
        case '7':
          title = 'Most Wanted'
          break
        case 'stores':
          title = 'Featured Stores'
          break
      }
    }
    return { ssrEntity: title }
  },
  data () {
    return {
      filterProductsFilter: {},
      query: null,
      featuredFilter: null,
      category: null,
      featured: null,
      selectedTab: 'ITEMS',
      categoryName: '',
      finishLoadItems: false,
      finishLoadPeople: false,
      finishLoadStores: false,
      filter: {},
      items: 0,
      people: 0,
      stores: 0
    }
  },
  head () {
    return {
      title: this.ssrEntity,
      meta: [
        { hid: 'og:title', name: 'og:title', content: this.ssrEntity },
        { hid: 'description', name: 'description', content: 'GOTit Social Ecommerce' },
        { hid: 'application-name', name: 'application-name', content: 'GOTit' },
        {
          hid: 'image',
          name: 'image',
          content: process.env.gotitLogo
        },
        {
          hid: 'og:image',
          name: 'og:image',
          content: process.env.gotitLogo
        },
        { hid: 'url', name: 'url', content: 'https://gotitstores.com' },
        { hid: 'og:url', name: 'og:url', content: 'https://gotitstores.com' }
      ]
    }
  },
  computed: {
    getItemsTabName () {
      if (this.featured) {
        switch (this.featured) {
          case '7':
            return 'Most Wanted'
          case '1':
            return 'Spacial Deals'
          case 'stores':
            return 'Featured Stores'
          default:
            return ''
        }
      } else if (this.categoryName && this.categoryName !== 'undefined') {
        return this.categoryName + ' - Items'
      } else {
        return 'Items'
      }
    }
  },
  watch: {
    '$route.query.featuredFilter' () {
      this.featuredFilter = this.$route.query.featuredFilter || ''
    },
    '$route.query.category' () {
      this.category = null
      this.filter = {}
      this.filterProductsFilter = {}
      setTimeout(() => {
        if (decodeURIComponent(this.$route.query.category).includes('search?category=')) {
          const arr = decodeURIComponent(this.$route.query.category).split('search?category=')
          this.category = arr[arr.length - 1]
        } else {
          this.category = this.$route.query.category
        }
        if (this.category) {
          this.featured = null
          this.selectedTab = 'ITEMS'
        }
      }, 50)
      this.query = ''
    },
    '$route.query.q' () {
      this.category = ''
      this.categoryName = ''
    },
    category (newVal, oldVal) {
      if (newVal) {
        if (newVal === 'all') {
          this.categoryName = 'All'
        } else {
          const categoryMap = this.$store.state.localStorage.categoryMap
          if (categoryMap) {
            this.categoryName = categoryMap[this.category]
          }
        }
      }
    }
  },
  mounted () {
    if (this.$route.hash) {
      this.selectedTab = this.$route.hash.replace('#', '').toUpperCase()
      this.selectTabWhenReady()
    }
    this.query = this.$route.query.q
    this.category = this.$route.query.category
    if (this.category && this.category.includes('create-set')) {
      this.$store.dispatch('api/sendLogMessage', 'create_set_click_mobile_menu').then().catch()
      this.$store.dispatch('api/trackEvent', {
        eventName: 'create_set_click_mobile_menu',
        params: {
          path: this.$route.path,
          page: 'item_page',
          itemId: this.itemId
        }
      }).then().catch()
      this.$router.replace({
        path: '/create-set'
      })
    }
    if (decodeURIComponent(this.$route.query.category).includes('search?category=')) {
      const arr = decodeURIComponent(this.$route.query.category).split('search?category=')
      this.category = arr[arr.length - 1]
    } else {
      this.category = this.$route.query.category
    }
    this.featured = this.$route.query.featured
    this.$root.$emit('set_toolbar_query', this.query)
    if (this.featured === 'stores') {
      this.selectedTab = 'STORES'
      this.featuredFilter = this.$route.query.featuredFilter
    }
    if (this.category) {
      if (this.category === 'all') {
        this.categoryName = 'All'
      } else if (this.$store.state.localStorage.categoryMap) {
        const categoryMap = this.$store.state.localStorage.categoryMap
        if (categoryMap) {
          this.categoryName = categoryMap[this.category]
        }
      }
    }
  },
  methods: {
    showFeaturedStores (filter) {
      if (filter) {
        this.$router.push({
          path: '/search?featured=stores&featuredFilter=' + filter
        })
      } else {
        this.$router.push({
          path: '/search?featured=stores'
        })
      }
    },
    selectTabWhenReady () {
      if (this.$refs.tabs) {
        this.selectTab(this.selectedTab)
      } else {
        setTimeout(() => {
          this.selectTabWhenReady()
        }, 200)
      }
    },
    selectTab (tab) {
      this.$refs.tabs.selectTab({ name: tab })
    },
    filterProducts (filter) {
      this.finishLoadItems = false
      this.filter = filter
    },
    onTabSelected (tab) {
      this.selectedTab = tab
    },
    onUserReady () {

    },
    onSearch (query) {
      console.log('onSearch')
      this.query = null
      setTimeout(() => {
        if (query) {
          if (this.$route.hash) {
            this.selectTab(this.$route.hash.replace('#', '').toUpperCase())
          }
          this.finishLoadPeople = false
          this.finishLoadItems = false
          this.finishLoadStores = false
          this.query = query
        }
      }, 50)
    },
    updateCounter (counter, count) {
      switch (counter) {
        case 'ITEMS':
          this.items = count
          this.finishLoadItems = true
          break
        case 'PEOPLE':
          this.people = count
          this.finishLoadPeople = true
          break
        case 'STORES':
          this.stores = count
          this.finishLoadStores = true
          break
      }
    }
  }
}
</script>

<style scoped>
  .search_grid {
    margin-top: 2em;
    max-width: 100%;
    padding-left: 0.5em;
    padding-right: 0.5em;
  }

  .mobile_design .search_grid {
    margin-top: 0.5em;
  }

  .stores_filter_parent {
    margin-top: 11.1em;
    background: white;
    width: 100%;
    text-align: center;
  }

  .mobile_design .stores_filter_parent {
    min-height: 9.9em;
    margin-top: 0;
    display: flex;
  }

  .stores_filter_child {
    margin-top: auto;
    width: 100%;
    padding:5px;
  }
  .see_all {
    cursor: pointer;
  }
  .see_all:hover {
    text-decoration: underline;
  }

  .featured_stores_filters {
    margin-left: 0.5em;
    text-align: center;
  }
  .featured_stores_filters span {
    color: #ed4956;
  }
  .tabs {
    width: 100%;
    margin-top: calc(50px + 8em);
    background-color: #efefef;
  }

  .tabs.filter {
    width: 100%;
    margin-top: unset;
    /*margin-top: calc(50px + 8em);*/
    /*margin-top: calc(50px);*/
    background-color: #efefef;
  }

  .mobile_design .tabs {
    background-color: white;
    margin-top: calc(50px + 4em);
  }

  .mobile_design .tabs.filter {
    /*margin-top: calc(50px + 4em);*/
    margin-top: calc(50px + -3.5em);
  }

  .gotit_search_not_fount {
    /*font-family: HKGroteskRegular;*/
    color: #262626;
    font-size: 16px;
    text-align: center;
    margin-top: 1em;
    line-height: 1.3em;
  }
</style>
